import SigninWithOTP from './components/SigninWithOTP';
import { Link } from 'react-router-dom';
import { VscHome } from 'react-icons/vsc';
import { FormattedMessage } from 'react-intl';

const Forgot = () => {
  return (
    <>
      <div className="login">
        <div className="login__wrapper">
          <div className="login__form">
            <Link to="/" title="Homepage" className="homepage-link">
              <VscHome className="homepage-link-icon" />
              <div className="title_container d-flex">
                <div className="logo-wrapper text-center">
                  <img src="/assets/images/logo.webp" alt="logo" className="logo" />
                </div>
                <div className="logo-text">
                  <span className="brand-main">
                    <FormattedMessage id="government_of_nepal" /> <br />
                    <FormattedMessage id="ministry_of_federal_afairs_and_general_administration" />
                  </span>
                  <span className="d-block text-danger sub-title">
                    <FormattedMessage id="provincial_and_local_goverment_support_program" />
                  </span>
                </div>
              </div>
            </Link>
            <span className="main-title pw-reset-title">
              <FormattedMessage id="password_reset" />
            </span>

            <SigninWithOTP from="forgot" />
            <div className="d-flex py-2">
              <Link
                to="/signin?login_type=otp"
                className="btn btn-sm btn-otp-alt me-2 d-block btn-round w-50 text-white">
                <FormattedMessage id="login_with_otp" />
              </Link>
              <Link
                to="/signin"
                className="ml-2 btn btn-sm btn-otp-alt ms-2 d-block btn-round w-50 text-white">
                <FormattedMessage id="login_with_password_or_pin" />
              </Link>
            </div>
            <hr />
            <div className="copyright">
              <p>
                Powered by :{' '}
                <a href="https://ideabreed.net/" target="_blank" rel="noreferrer">
                  Idea Breed IT Solution Pvt. Ltd.
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Forgot;
